export default __webpack_public_path__ + "static/media/assessment_glide_2_2.7031c24a.svg";